import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const traderDetailsSchema = baseObjectSchema.extend({
  code: z.string(),
  name: z.string(),
  title: z.string().optional(),
  job: z.string().optional(),
  taxNumber: z.string().optional(),
  doy: z.string().optional(),
  country: z.string().optional(),
  city: z.string().optional(),
  address: z.string().optional(),
  zipCode: z.string().optional(),
  email: z.string().optional(),
  telephone1: z.string().optional(),
  telephone2: z.string().optional(),
  remarks: z.string().optional(),
  adt: z.string().optional(),
  adt_date: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  passportExpiredDate: z.string(),
  passportId: z.string().optional(),
  socialNumberId: z.string().optional(),
  taxOfficeId: z.string().optional(),
});

export const traderSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  title: z.string().optional(),
  job: z.string().optional(),
  taxNumber: z.string().optional(),
  city: z.string().optional(),
  address: z.string().optional(),
  zipCode: z.string().optional(),
  isFromManager: z.boolean(),
  doy: z.string().optional(),
});

export const findTraderSchema = traderSchema.extend({
  isFromAADE: z.boolean().optional(),
});

export const getTradersSchema = z.array(traderSchema);

export type GetTraderResponse = z.infer<typeof traderSchema>;
export type GetTradersResponse = z.infer<typeof getTradersSchema>;
export type FindTradersResponse = z.infer<typeof findTraderSchema>;
